'use strict';

var template = '\n    <div >\n    \n        <button ng-if="!vm.editMode && !vm.model" ng-click="vm.edit()" class="btn btn-default btn-xs"><i class="fa fa-plus"></i></button>\n        <div ng-if="!vm.editMode && vm.model" class="input-group">\n            <span>{{vm.model}} </span>&nbsp;\n            <button ng-click="vm.edit()"  class="btn btn-default btn-xs"><i class="fa fa-pencil"></i></button>\n        </div>\n        \n        <div ng-if="vm.editMode" class="input-group">\n        \n        <input  \n            type="text" \n            class="form-control input-sm"\n            ng-model="vm.model"\n        />\n        \n        <span class="input-group-btn"> \n            <button type="button" class="btn btn-default btn-sm" ng-click="vm.save()"><i class="fa fa-check"></i></button> \n            <button type="button" class="btn btn-default btn-sm" ng-click="vm.cancel()"><i class="fa fa-times"></i></button>\n        </span>\n        </div>\n    </div>\n';

/*@ngInject*/
module.exports = function () {
    return {
        scope: {
            model: '=ngModel',
            onSave: '&'
        },
        restrict: 'E',
        replace: true,
        template: template,
        require: 'ngModel',
        controllerAs: 'vm',
        bindToController: true,
        controller: function controller() {
            var vm = this;
            vm.save = function () {
                if (vm.onSave) {
                    vm.onSave();
                }
                vm.editMode = false;
            };

            vm.edit = function () {
                vm.editMode = true;
                vm.temp_model = angular.copy(vm.model);
            };

            vm.cancel = function () {
                vm.editMode = false;
                vm.model = vm.temp_model;
            };
        }
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/editableText.directive.js
 **/